export default "__VITE_ASSET__Kp$A1tAO__"